import styles from './PageNotFound.less';

import React, { PureComponent } from 'react';
import { Text, PageBlock } from 'seek-style-guide/react';

export default class PageNotFound extends PureComponent {
  render() {
    return (
      <PageBlock className={styles.root} data-automation="pageNotFound">
        <Text heading regular>
          Sorry, there doesn’t seem to be anything here&hellip;
        </Text>
        <ul>
          <li className={styles.li}>
            <Text>Check the URL, there may be a typo.</Text>
          </li>
          <li className={styles.li}>
            <Text>If all else fails, try going back.</Text>
          </li>
        </ul>
      </PageBlock>
    );
  }
}
